export default __webpack_public_path__ + "static/media/AS.6f7b97f6.svg";